import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import styles from './styles.scss';

class Dropdown extends Component {
  render(){
    const { navSticky } = this.props;
    const transparentNav = location.pathname === '/';

    return (
      <div className={styles.learnMore}>
        <a className={`h3 ls1 ${styles.link}`} onClick={() => this.goTo('how-it-works')}>HOW IT WORKS</a>
        <a className={`h3 ls1 ${styles.link}`} onClick={() => this.goTo('designers')}>MEET OUR DESIGNERS</a>
        <Link to="/get-started" className={`btn ${styles.menu} ${navSticky || !transparentNav ? 'btn-dc-primary' : 'btn-dc-transparent'}`}>
          <span>SUBMIT A BRIEF</span>
        </Link>
      </div>
    );
  }

  goTo = (anchorName, offset) => {
    if (location.pathname === '/') {
      this.props.anchorTo(anchorName, offset);
    } else {
      browserHistory.push(`/#${anchorName}`);
    }
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Navigation/Dropdown/index.js